import { useDispatch, useSelector } from "react-redux";
import { bindActionCreators } from "redux";
import { useEffect } from "react";
import packageActionsImp from "../../../Actions/Voss/packageActions";
import Card from "../../../Components/Card/Card";
import { PriceAdjustmentPackagesTable } from "../../../Components/Voss/PriceAdjustment/PriceAdjustmentPackagesTable";

export function PriceAdjustmentContainer({ }) {
    const dispatch = useDispatch();
    const packages = useSelector((state) => state.PackageReducer.packages);
    const pacakgeActions = bindActionCreators(packageActionsImp, dispatch);
    const isLoading = useSelector((state) => state.CommonReducer.dataLoading.packages);

    useEffect(() => {
        pacakgeActions.getPackages();
    }, []);

    return <Card>
        <Card.Header>
            <Card.Header.Title>Prisjusteringar</Card.Header.Title>
        </Card.Header>
        <Card.Content isLoading={isLoading}>
            <PriceAdjustmentPackagesTable packages={packages} />
        </Card.Content>
    </Card>
}